import { render, staticRenderFns } from "./TrsProjectForm.vue?vue&type=template&id=71f7d2ea&scoped=true"
import script from "./TrsProjectForm.vue?vue&type=script&lang=js"
export * from "./TrsProjectForm.vue?vue&type=script&lang=js"
import style0 from "./TrsProjectForm.vue?vue&type=style&index=0&id=71f7d2ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71f7d2ea",
  null
  
)

export default component.exports